import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form, Select, Button, Card, InputNumber } from 'antd';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Input from '@ui/Input'
import ActionButtonsBar from '@ui/ActionButtonsBar';
import { validateFormHelper, postHelper, putHelper, deleteHelper } from './helpers'
import {Rate, RatesApi} from './RatesTypes'
import TextArea from '@ui/TextArea';

interface propsTypes {
    ratePlanType: Array<{codeName: string}>,
    guestType: Array<{codeName: string}>,
    rate: Rate,
    mode: string,
    setDetailViewOn: (e:boolean) => void,
    setEditLoading: (e: boolean) => void,
    update: () => void,
}

const RateDetail = (props: propsTypes) => {
    const Option = Select.Option;
    const [form] = Form.useForm();
    const [disableFlag, setDisableFlag] = useState<boolean>(false)
    const [isonEdit, setIsOnEdit] = useState<boolean>(false)

    const policytype = ['Government', 'Negotiated', 'Preferred', 'Other']
    const [descriptionList, setDescriptionList] = useState<Array<{description?: string}>>([{}])


    // Init
    useEffect(() => {
        setDescriptionList(props.rate.descriptions || [{}])
        form.setFieldsValue({
          name: props.rate.name,
          rateplantype: props.rate.rateplantype,
          policytype: props.rate.policytype,
          guesttype: props.rate.guesttype,
          minimumnights: props.rate.minimumnights,
          corporateidrequired: props.rate.corporateidrequired,
          idrequired: props.rate.idrequired,
          descriptions: props.rate.descriptions || [{}]
        })
        props.mode === 'Add' && setIsOnEdit(true)
        validateForm()
    },[])

    // validating the required values have been fufilled properly
    const validateForm = useCallback(() => {
        validateFormHelper(form, setDisableFlag)
    },[form])


    const getBody = () => {
        const values = form.getFieldsValue(true)
        let body = {}
        if (props.mode === 'Add') {
            body = {
                    "policies":{
                      "ratepolicy": [{
                        "name": values.name,
                        "rateplantype": values.rateplantype,
                        "policytype": values.policytype,
                        "guesttype": values.guesttype,
                        "minimumnights": values.minimumnights,
                        "corporateidrequired" : values.corporateidrequired,
                        "idrequired" : values.idrequired,
                        "descriptions": values.descriptions
                       }]
                    }
             }
        } 
        if (props.mode === 'Edit') {
            body = {
              "policies":{
                "ratepolicy": [{
                  "rateid": props.rate.rateid,
                  "ratelangid": props.rate.ratelangid,
                  "name": values.name,
                  "rateplantype": values.rateplantype,
                  "policytype": values.policytype,
                  "guesttype": values.guesttype,
                  "minimumnights": values.minimumnights,
                  "corporateidrequired" : values.corporateidrequired,
                  "idrequired" : values.idrequired,
                  "descriptions": values.descriptions
                 }]
              }
             }
        } 
        return body
    }

    const save = async () => {
            let response : RatesApi | null = null;
            props.setEditLoading(true)
            try {
            
                const bodyShape = getBody()
                if (props.mode === 'Add') {
                    response = await postHelper('/property/policies/rate', bodyShape)
                }
                if (props.mode === 'Edit') {
                    response = await putHelper('/property/policies/rate', bodyShape)
                }
                // persisting the post data
                if (response && response.result.success && response.errors.length === 0) { 
                    setIsOnEdit(false)
                    form.resetFields();
                    props.update()
                }
                } catch (error) {
                return error
                }
        }

    const erase = async () => {
    
        let response : RatesApi | null = null;
        props.setEditLoading(true)
        try {
        
            const bodyShape = {
                "policies":{
                  "ratepolicy": [{
                    "rateid": props.rate.rateid,
                    "ratelangid": props.rate.ratelangid
                   }]
                }
             }
            response = await deleteHelper('/property/policies/rate', bodyShape)
            // persisting the post data
            if (response && response.result.success && response.errors.length === 0) { 
                setIsOnEdit(false)
                form.resetFields();
                props.update()
            }
            } catch (error) {
            return error
            }
    }

    const cancel = () => {
        if ( props.mode === 'Add' ) {
            props.setDetailViewOn(false)
        }

        if ( props.mode === 'Edit' ) {
            setIsOnEdit(false)
        }
    }

    const addDescription = () => {
      let currentValues = form.getFieldsValue(true)
      currentValues = currentValues.descriptions
      if (currentValues.length < 5) {
          let s = [...currentValues]
          s.push({description: ''})
          setDescriptionList(s)
          form.setFieldsValue({ descriptions: s})
      }
    }

    const deleteDescription = (i: number) => {
        let currentValues = form.getFieldsValue(true)
        currentValues = currentValues.descriptions
        if (currentValues.length > 1) {
            let s = [...currentValues]
            s.splice(i, 1)
            setDescriptionList(s)
            form.setFieldsValue({ descriptions: s})
        }
    }

    const getDescriptionsList = () => {
      return descriptionList.map((item, index) => {
        return <>
            <Col span={16} className="col-margin" key={index}>
                        <Form.Item
                            label={`Description ${index +1}`}
                            name={['descriptions', index, 'description']}
                            rules={[{ required: true, message: 'This field is required' }]}
                        >
                          <TextArea
                              maxLength={300}
                              edit={isonEdit}
                              disabled={!isonEdit}
                            />
                        </Form.Item>
                        {descriptionList.length < 5 && index + 1 === descriptionList.length ?
                            <div>
                                    <Button
                                        type="link"
                                        onClick={()=>{
                                          addDescription()
                                        }}
                                        icon={<PlusOutlined />}
                                        style={{ display: 'flex', alignItems: 'center', background: '#fff', float:'right' }}
                                        >
                                        {`Add Description ${descriptionList.length + 1}`}
                                    </Button>
                            </div>
                        : null}
                    </Col>
                    {descriptionList.length > 1 && 
                        <CloseCircleOutlined className="panel-btn" 
                        onClick={() => deleteDescription(index)}/>
                    }
        </>
      })
    }

    return (
      <Card style={{ marginTop: -15, marginBottom: 65 }}>
        <div className='col-12'>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <span></span>

            {!isonEdit && (
              <>
                <div style={{ margin: '0 10px 0 0' }}>
                  <Button
                    style={{
                      background: '#004771',
                      color: '#fff',
                      width: 60,
                      height: 28,
                    }}
                    onClick={() => props.setDetailViewOn(false)}>
                    Back
                  </Button>
                </div>
                <div>
                  <Button
                    style={{
                      background: '#004771',
                      color: '#fff',
                      width: 60,
                      height: 28,
                    }}
                    onClick={() => setIsOnEdit(true)}>
                    Edit
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{}}
          className={!isonEdit ? 'is-disabled-fields' : ''}
          onValuesChange={validateForm}>
          <Row gutter={24}>
            <Col span={7}>
              <Form.Item
                label='Name'
                name='name'
                rules={[
                  {
                    max: 128,
                    message: 'You have reached the max character length of 128',
                  },
                  { required: true, message: 'This field is required' },
                ]}>
                <Input maxLength={128} edit={isonEdit} />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item label='Rate Plan Type' name='rateplantype'>
                <Select allowClear showSearch>
                  {props.ratePlanType.map((item, index) => {
                    return <Option key={index} value={item.codeName}>{item.codeName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item label='Policy Type' name='policytype'>
                <Select allowClear showSearch>
                  {policytype.map((item, index) => {
                    return <Option key={index} value={item}>{item}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={7}>
              <Form.Item label='Guest Type' name='guesttype'>
                <Select allowClear showSearch>
                  {props.guestType.map((item, index) => {
                    return <Option key={index} value={item.codeName}>{item.codeName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item label='Corporate ID Required' name='corporateidrequired'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item label='ID Required' name='idrequired'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={7}>
              <Form.Item label='Minimum Room Nights Required' name='minimumnights'
                rules={[
                  {
                    pattern: /^\d*(\.\d*)?$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
                {getDescriptionsList()}
          </Row>
        </Form>
        <ActionButtonsBar
          onDelete={props.mode === 'Edit' && erase}
          onCancel={cancel}
          onSave={save}
          disabledSave={disableFlag}
          show={isonEdit}
        />
      </Card>
    )
}

export default RateDetail